import React, { useContext, useEffect } from 'react';
import { IProps } from './types';
import { useParams } from 'react-router';
import { useMutation } from '@apollo/react-hooks';
import { CUSTOMER_DELETE_CONFIRM } from '@components/pages/AccountDeleteConfirmPage/queries';
import { customerDeleteConfirm } from '@components/pages/AccountDeleteConfirmPage/__generated__/customerDeleteConfirm';
import { history } from '@src/history';
import { CredentialContext, credentialType } from '@providers';
import { baseUrl } from '@src/app/routes';
import { Loading } from '@atoms';
import { notEmpty } from '@src/utils/validation';

const AccountDeleteConfirmPage: React.FC<IProps> = ({}: IProps) => {
  const { token } = useParams();
  const { currentUser, logOut } = useContext<credentialType>(CredentialContext);
  const [confirmCustomerDelete] = useMutation<customerDeleteConfirm>(CUSTOMER_DELETE_CONFIRM, {
    variables: {
      id: currentUser?.user?.id,
      input: {
        token,
      },
    },
    onCompleted: (data) => {
      const errors = data?.customerDeleteConfirm?.errors;
      if (notEmpty(errors) && errors?.length > 0) {
        const msg = errors
          ?.map((e) => {
            return e?.message ?? '';
          })
          .join('\n');
        alert(msg);
      } else {
        logOut();
        alert('Your account successfully deleted.');
      }
      history.push(baseUrl);
    },
  });

  useEffect(() => {
    confirmCustomerDelete();
  }, []);

  return <Loading />;
};

export { AccountDeleteConfirmPage };
